import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from "devextreme/ui/dialog";
import { AmsNotifierService } from "../../../../../../../shared/services/ams-notifier.service";
import { LanguageService } from "../../../../../../../shared/services/language.service";
import { TimeService } from "../../../../../_api/services/time.service";

@Component({
  selector: "app-edit-transport-equipment",
  templateUrl: "./edit-transport-equipment.component.html",
  styleUrls: ["./edit-transport-equipment.component.css"],
})
export class EditTransportEquipmentComponent implements OnInit, OnChanges {
  @ViewChild("datagriddx", { static: false }) dataGrid: DxDataGridComponent;
  @Input() gridDataSource: any;
  equipmentDataSource: any;
  @Output() loading = new EventEmitter<boolean>(); //emit event to parent(project-portal.component) to show load indicator
  @Input() transport: any;
  @Output() changed = new EventEmitter();
  showEquipmentTime: boolean = true;
  validateHoursMessage = this.languageService.LNG(
    "Label.Cannot.Enter.More.Than.23.Hours"
  );
  validateMinutesMessage = this.languageService.LNG(
    "Label.Cannot.Enter.More.Than.59.Minutes"
  );
  validateEquipmentMessage = this.languageService.LNG(
    "Please.Select.Equipment"
  );
  isEditingDisabled = false;

  newEquipment: any = {
    EquipmentId: -1,
    Hours: null,
    Minutes: null,
    EquipmentTypeId: -1,
    IsMainEquipment: false,
    IsLoadedEquipment: false,
  };

  equipmentTypes: any[] = [
    {
      Id: 1,
      Name: this.languageService.LNG("Label.Main.Equipment"),
    },
    {
      Id: 2,
      Name: this.languageService.LNG("Label.Loaded.Equipment"),
    },
  ];

  equipmentTypeLabel =
    this.languageService.LNG("Label.Main.Equipment") +
    " / " +
    this.languageService.LNG("Label.Loaded.Equipment");

  constructor(
    public languageService: LanguageService,
    private timeService: TimeService,
    private amsNotifierService: AmsNotifierService
  ) {}

  ngOnInit() {
    this.showEquipmentTime = this.transport.ShowEquipmentTime;
    this.timeService.getEquipment().subscribe(
      (result: any) => {
        this.equipmentDataSource = result.Data;
      },
      (error) => {}
    );
  }

  ngOnChanges() {
    this.isEditingDisabled = this.transport.TransportStatusId >= 4;
  }

  onInitNewRow(e: any) {
    e.data.IsMainEquipment = false;
    e.data.LoadedEquipment = false;
  }

  createNewEquipment() {
    if (this.isValid()) {
      this.loading.emit(true);
      let seconds = this.getSeconds(
        this.newEquipment.Hours,
        this.newEquipment.Minutes
      );

      let equipment = {
        CarrierId: this.transport.CarrierId,
        EquipmentId: this.newEquipment.EquipmentId,
        IsMainEquipment: this.newEquipment.EquipmentTypeId == 1,
        LoadedEquipment: this.newEquipment.EquipmentTypeId == 2,
        Seconds: seconds,
      };

      this.timeService.insertEquipment(equipment).subscribe(
        (result: any) => {
          if (result.IsSuccess) {
            this.amsNotifierService.success(
              this.languageService.LNG("Label.SavedOK")
            );
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            this.newEquipment = {
              EquipmentId: -1,
              Hours: null,
              Minutes: null,
              EquipmentTypeId: -1,
            };
            this.refresh();
          } else {
            this.loading.emit(false);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        },
        (error) => {
          this.loading.emit(false);
        }
      );
    }
  }

  isValid(): boolean {
    let isValid: boolean = true;

    if (this.newEquipment.EquipmentId < 0) {
      this.amsNotifierService.error(this.validateEquipmentMessage);
      isValid = false;
    }
    if (this.newEquipment.Hours > 23) {
      this.amsNotifierService.error(this.validateHoursMessage);
      isValid = false;
    }
    if (this.newEquipment.Minutes > 59) {
      this.amsNotifierService.error(this.validateMinutesMessage);
      isValid = false;
    }

    return isValid;
  }

  refresh() {
    this.loading.emit(true);
    this.timeService
      .getEquipmentByTransportCollection(this.transport.TransportCollectionId)
      .subscribe(
        (result: any) => {
          this.loading.emit(false);
          if (result.IsSuccess) {
            this.gridDataSource = result.Data;
            this.changed.emit();
          } else {
            this.amsNotifierService.error(result.ErrorMessage);
          }
        },
        (error) => {
          this.loading.emit(false);
        }
      );
  }

  getSeconds(hours, minutes): number {
    if (!hours) {
      hours = 0;
    }
    if (!minutes) {
      minutes = 0;
    }
    let newHHSeconds = hours * 3600;
    return newHHSeconds + Number(minutes) * 60;
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }
      let seconds = this.getSeconds(
        e.newData.TotSecondsToHH,
        e.newData.TotSecondsTomm
      );
      let equipment = {
        CarrierId: this.transport.CarrierId,
        EquipmentId: e.newData.EquipmentId,
        IsMainEquipment: e.newData.IsMainEquipment,
        LoadedEquipment: e.newData.LoadedEquipment,
        Seconds: seconds,
      };
      let keyCarrierId = this.transport.CarrierId;
      let keyEquipmentId = e.key.EquipmentId;

      this.timeService
        .updateEquipment(
          keyCarrierId,
          keyEquipmentId,
          equipment.EquipmentId,
          equipment.IsMainEquipment,
          equipment.LoadedEquipment,
          equipment.Seconds
        )
        .subscribe(
          (result: any) => {
            this.loading.emit(false);
            if (result.IsSuccess) {
              resolve(false);
              this.amsNotifierService.success(
                this.languageService.LNG("Label.SavedOK")
              );
              if (result.Message != null && result.Message.length > 0) {
                this.amsNotifierService.error(result.Message);
              }
              e.component.cancelEditData();
              this.refresh();
            } else {
              this.loading.emit(false);
              resolve(true);
              this.amsNotifierService.error(result.ErrorMessage);
            }
          },
          (error) => {
            this.loading.emit(false);
            resolve(true);
          }
        );
    });
    e.cancel = isCanceled;
  }

  onRowRemoving(e: any) {
    let equipmentIds: number[] = [];
    equipmentIds.push(e.data.EquipmentId);

    this.timeService
      .deleteEquipmentByEquipmentIds(this.transport.CarrierId, equipmentIds)
      .subscribe(
        (result: any) => {
          this.amsNotifierService.success(
            this.languageService.LNG("Label.DeletedOK")
          );
          if (result.Message != null && result.Message.length > 0) {
            this.amsNotifierService.error(result.Message);
          }
          this.loading.emit(false);
          this.refresh();
          this.dataGrid.selectedRowKeys = [];
        },
        (error) => {
          this.loading.emit(false);
        }
      );
  }
}
